import React, { forwardRef, useCallback } from 'react';
import { useLocation } from './useLocation';
import { useRouter } from './useRouter';
/**
 * Компонент перехода по новому адресу
 */
export const Link = forwardRef(function Link({ children, onClick, replace, to, onlyExists = false, ...anchorProps }, ref) {
    const [, navigate] = useLocation();
    const router = useRouter();
    const href = typeof to === 'function' ? to() : to || '/';
    const handleClick = useCallback((event) => {
        // ignores the navigation when clicked using right mouse button or
        // by holding a special modifier key: ctrl, command, win, alt, shift
        if (event.ctrlKey || event.metaKey || event.altKey || event.shiftKey || event.button !== 0) {
            if (onClick) {
                onClick(event);
            }
            return;
        }
        if (onlyExists && href) {
            const exists = router.checkPath(href, true, true);
            if (!exists[0]) {
                if (onClick) {
                    onClick(event);
                }
                return;
            }
        }
        event.preventDefault();
        if (href) {
            navigate(href, replace);
        }
        if (onClick) {
            onClick(event);
        }
    }, [href, onClick, navigate, replace, onlyExists]);
    const extraProps = { href, onClick: handleClick };
    return React.createElement('a', { ref, ...anchorProps, ...extraProps }, children);
});
